import {
  ListManageAreaApiRequest,
  ListAvailableCourierApiRequest,
  ListGeoAddressApiRequest,
  TransferAreaApiRequest,
  AvailableGeoAddressApiRequest
} from "@/data/payload/api/ManageAreaApiRequest";

export class ManageAreaEndpoint {
  getList(params: ListManageAreaApiRequest) {
    return `/horde/v1/partner-area-dedicated?${params.toQueryString()}`;
  }
  getSummaryGeoAddress() {
    return "/horde/v1/partner-area-dedicated/summary-geo-address";
  }
  getTransferArea(uid: string) {
    return `/horde/v1/partner-area-dedicated/${uid}`;
  }
  postTransferArea() {
    return "/horde/v1/partner-area-dedicated/transfer";
  }
  getGeoAddress(params: ListGeoAddressApiRequest) {
    return `/horde/v1/partner-area-dedicated/geo-address?${params.toQueryString()}`;
  }
  getAvailableCourier(params: ListAvailableCourierApiRequest) {
    return `/horde/v1/partner-area-dedicated/available-courier?${params.toQueryString()}`;
  }
  delete(uid: string) {
    return `/horde/v1/partner-area-dedicated/${uid}`;
  }
  getAvailableGeoAddress(params: AvailableGeoAddressApiRequest) {
    return "horde/v1/partner-area-dedicated/available-geo-address?"+params.toQueryString();
  }
  createArea() {
    return "horde/v1/partner-area-dedicated";
  }
  getDetail(uid: string) {
    return `/horde/v1/partner-area-dedicated/${uid}`;
  }
  update(uid: string) {
    return `/horde/v1/partner-area-dedicated/${uid}`;
  }
}
